<footer class="footer__section">
  <div class="footer-container bg-dark-footer">
    <div class="text-md-center">
      <div class="row footer-row">
        <div class="col-md-12">
          <div class="footer-info">
            <p
              [innerHTML]="
                content?.footer?.info?.copyright +
                '<span>&nbsp;|&nbsp;</span>' +
                content?.footer?.info?.disclaimer1
              "
            ></p>
            <p [innerHTML]="content?.footer?.info?.disclaimer2"></p>
          </div>
        </div>
      </div>
    </div>
    <div class="col mt-4 text-center footer-bottom-rows">
      <p class="footer__section--text mb-3">
        <span class="feedbackLink mx-auto text-white">
          <a href="javascript:void(0)">Website Feedback</a>
        </span>
      </p>
      <!-- Footer List -->
      <div class="align-items-center justify-content-center">
        <div class="social-icons-container ng-star-inserted">
          <a
            (click)="openModal($event, item.iconLink)"
            *ngFor="let item of content?.footer?.socialIcons; let i = index"
            aria-haspopup="true"
            class="facebook circle-outline picturefill-background"
            href="javascript:void(0);"
            id="footer-{{ item.iconAlt | lowercase }}"
          >
            <span [attr.data-src]="item.iconLogo"></span>
            <img [attr.alt]="item.iconAlt" src="{{ item.iconLogo }}" />
          </a>
        </div>
        <!-- The  [focusOnModal]="showModal" was removed, need validation -->
        <idp-simple-modal
          (ctaAction)="submitModal()"
          (openChange)="closeModal()"
          [ariaLabelSubmit]="
            getSubmitButtonLabel(content.accessibilityPopUp.secondaryLabel)
          "
          [cancelButtonTitle]="content.accessibilityPopUp.primaryLabel"
          [headerStyle]="'light'"
          [modalStyle]="'secondary focus-trap'"
          [modalTitle]="content.accessibilityPopUp.popupTitle"
          [open]="showModal"
          [showCloseIcon]="false"
          [showFooter]="true"
          [showSubmitButton]="true"
          [submitButtonStyle]="'primary'"
          [submitButtonTitle]="content.accessibilityPopUp.secondaryLabel"
          [type]="modalType"
          idpAppModalfocus
        >
          <div
            [innerHTML]="axContent"
            class="footer-external-link-confirmation-container"
          ></div>
        </idp-simple-modal>
        <!--Disabled CLS for footer Slim Starts-->
        <div
          class="language-selector-container text-center text-md-left cls-disable"
        >
          <div
            class="footer__section-btn-link language-firstitem icon-Language-selector"
          >
            <span
              class="footer__section-icon icon-language-selector text-center"
            >
              United States - English
            </span>
          </div>
          <div class="footer__section-btn-link icon-language-espanol">
            Español
          </div>
        </div>
        <!--Disabled CLS for footer Slim Ends-->
      </div>
      <!-- End footer List -->
    </div>
  </div>
</footer>
<!-- ========== END FOOTER ========== -->
